<main>
  <slot/>
</main>

<style>
  main {
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-feature-settings: normal;
    color: rgb(34 34 34);
    font-size: 1rem;
    line-height: 1.5rem;
    border-width: 0;
    border-style: solid;
    border-color: #e5e7eb;
    position: relative;
    display: flex;
    flex-grow: 1;
    overflow: hidden;
  }
  @media (max-width: 768px) {
    main {
      flex-direction: column !important;
      overflow: visible;
    }
  }
</style>